import { FETCH_COMMENTS_SUCCESS } from '../comments/actionTypes';
import {
  FETCH_USERS_REQUEST,
  FETCH_USERS_SUCCESS,
  FETCH_USERS_FAILURE,
  OPEN_EDIT_PAGE,
  FETCH_USER_REQUEST,
  FETCH_USER_SUCCESS,
  FETCH_USER_FAILURE,
  UPDATE_USERS_REQUEST,
  UPDATE_USERS_FAILURE,
  UPDATE_USERS_SUCCESS,
  DELETE_USERS_REQUEST,
  DELETE_USERS_FAILURE,
  DELETE_USERS_SUCCESS,
  KPI_USERS_FAILURE,
  KPI_USERS_SUCCESS,
  KPI_USERS_REQUEST,
  UPDATE_PWD_REQUEST,
  UPDATE_PWD_SUCCESS,
  UPDATE_PWD_FAILURE,
  REQUEST_PASSWORD_RESET,
  REQUEST_PASSWORD_RESET_SUCCESS,
  REQUEST_PASSWORD_RESET_FAILURE,
  VALIDATE_PASSWORD_TOKEN,
  VALIDATE_PASSWORD_TOKEN_SUCCESS,
  VALIDATE_PASSWORD_TOKEN_FAILURE,
  RESET_PASSWORD,
  RESET_PASSWORD_SUCCESS,
  RESET_PASSWORD_FAILURE,
  REGISTER_USER_REQUEST,
  REGISTER_USER_SUCCESS,
  REGISTER_USER_FAILURE,
  ACTIVATE_ACCOUNT_REQUEST,
  ACTIVATE_ACCOUNT_SUCCESS,
  ACTIVATE_ACCOUNT_FAILURE,
  FETCH_CUSTOMERS_REQUEST,
  FETCH_CUSTOMERS_FAILURE,
  FETCH_CUSTOMERS_SUCCESS,
  KPI_CUSTOMERS_FAILURE,
  KPI_CUSTOMERS_SUCCESS,
  KPI_CUSTOMERS_REQUEST,
  VERIFY_USER_REQUEST,
  VERIFY_USER_SUCCESS,
  VERIFY_USER_FAILURE,
  BAN_USER_REQUEST,
  BAN_USER_SUCCESS,
  CLEAR_USER_ERRORS, // Nouvelles imports
  CLEAR_USER_SUCCESS,
  RESEND_ACTIVATION_EMAIL_REQUEST,
  RESEND_ACTIVATION_EMAIL_SUCCESS,
  RESEND_ACTIVATION_EMAIL_FAILURE,
  SEND_EMAIL_ADMIN_FAILURE,
  SEND_EMAIL_ADMIN_SUCCESS,
  SEND_EMAIL_ADMIN_REQUEST,
  ACTIVATE_USER_REQUEST,
  ACTIVATE_USER_SUCCESS,
  ACTIVATE_USER_FAILURE,
} from './actionTypes';

const initialState = {
  users: [],
  companies: [],
  customers: [],
  user: null,
  loadingUser: false,
  errorUser: null,
  errorsUser: null,
  editItemId: null,
  usersKpi : null,
  customersKpi : null,
  userAdded: null,
  success: false,
  tokenValid: false,
  userId: null,
  passwordResetSuccess: false,
  registerSuccess: false,
  resendLoading: false,
  resendSuccess: false,
  resendError: false,
  sendAdminLoading: false,
  sendAdminSuccess: false,
  sendAdminError: false,
  activationSuccess: false,
  activationLoadingUser: false,
  activationError: null,
  userVerified: false
};

const Users = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_USERS_REQUEST:
      return {
        ...state,
        loadingUser: true,
        errorUser: null,
        userAdded: false
      };
    case FETCH_USERS_SUCCESS:
      return {
        ...state,
        loadingUser: false,
        companies: action.payload.data
          .map(item => item.company)
          .filter((value, index, self) => self.indexOf(value) === index),
        users: action.payload.data,
        errorsUser: action.payload.errorsUser,
      };
    case FETCH_USERS_FAILURE:
      return {
        ...state,
        loadingUser: false,
        errorUser: action.payload,
      };
    case FETCH_CUSTOMERS_REQUEST:
      return {
        ...state,
        loadingUser: true,
        errorUser: null,
        userAdded: false
      };
    case FETCH_CUSTOMERS_SUCCESS:
      return {
        ...state,
        loadingUser: false,
        customers: action.payload.data,
        errorsUser: action.payload.errorsUser,
      };
    case FETCH_CUSTOMERS_FAILURE:
      return {
        ...state,
        loadingUser: false,
        errorUser: action.payload,
      };
    case FETCH_USER_REQUEST:
      return {
        ...state,
        loadingUser: true,
        errorUser: null,
        userAdded: false
      };
    case FETCH_USER_SUCCESS:
      return {
        ...state,
        loadingUser: false,
        user: action.payload.data,
      };
    case FETCH_USER_FAILURE:
      return {
        ...state,
        loadingUser: false,
        errorUser: action.payload,
      };
    case UPDATE_USERS_REQUEST:
      return {
        ...state,
        loadingUser: true,
        errorUser: null,
        userAdded: false
      };
    case UPDATE_USERS_SUCCESS:
      return {
        ...state,
        loadingUser: false,
        user: null,
        userAdded: action.payload.data
      };
    case UPDATE_USERS_FAILURE:
      return {
        ...state,
        loadingUser: false,
        errorUser: action.payload,
      };
    case UPDATE_PWD_REQUEST:
      return {
        ...state,
        loadingUser: true,
        errorUser: null,
        userAdded: false
      };
    case UPDATE_PWD_SUCCESS:
      return {
        ...state,
        loadingUser: false,
        user: null,
        userAdded: true
      };
    case UPDATE_PWD_FAILURE:
      return {
        ...state,
        loadingUser: false,
        errorUser: action.payload,
      };
    case DELETE_USERS_REQUEST:
      return {
        ...state,
        loadingUser: true,
        errorUser: null,
        userAdded: false
      };
    case DELETE_USERS_SUCCESS:
      return {
        ...state,
        userAdded: true,
        loadingUser: false,
        users: state.users.filter(user => user.id !== action.payload),
      };
    case DELETE_USERS_FAILURE:
      return {
        ...state,
        loadingUser: false,
        errorUser: action.payload,
      };
    case OPEN_EDIT_PAGE:
      return {
        ...state,
        editItemId: action.payload.id,
      };
    case KPI_USERS_REQUEST:
      return {
        ...state,
        loadingUser: true,
        errorUser: null,
        userAdded: false
      };
    case KPI_USERS_SUCCESS:
      return {
        ...state,
        loadingUser: false,
        usersKpi: action.payload,
      };
    case KPI_USERS_FAILURE:
      return {
        ...state,
        loadingUser: false,
        errorUser: action.payload,
      };
    case KPI_CUSTOMERS_REQUEST:
      return {
        ...state,
        loadingUser: true,
        errorUser: null,
        userAdded: false
      };
    case KPI_CUSTOMERS_SUCCESS:
      return {
        ...state,
        loadingUser: false,
        customersKpi: action.payload,
      };
    case KPI_CUSTOMERS_FAILURE:
      return {
        ...state,
        loadingUser: false,
        errorUser: action.payload,
      };
    case REQUEST_PASSWORD_RESET:
      return {
        ...state,
        loadingUser: true,
        success: false,
        errorUser: null
      };
    case REQUEST_PASSWORD_RESET_SUCCESS:
      return {
        ...state,
        loadingUser: false,
        success: true
      };
    case REQUEST_PASSWORD_RESET_FAILURE:
      return {
        ...state,
        loadingUser: false,
        errorUser: action.payload
      };
    case VALIDATE_PASSWORD_TOKEN:
      return {
        ...state,
        loadingUser: true,
        tokenValid: false,
        errorUser: null
      };
    case VALIDATE_PASSWORD_TOKEN_SUCCESS:
      return {
        ...state,
        loadingUser: false,
        tokenValid: true,
        userId: action.payload.userId
      };
    case VALIDATE_PASSWORD_TOKEN_FAILURE:
      return {
        ...state,
        loadingUser: false,
        tokenValid: false,
        errorUser: action.payload
      };
    case RESET_PASSWORD:
      return {
        ...state,
        loadingUser: true,
        passwordResetSuccess: false,
        errorUser: null
      };
    case RESET_PASSWORD_SUCCESS:
      return {
        ...state,
        loadingUser: false,
        passwordResetSuccess: true
      };
    case RESET_PASSWORD_FAILURE:
      return {
        ...state,
        loadingUser: false,
        errorUser: action.payload
      };
    case REGISTER_USER_REQUEST:
      return {
        ...state,
        loadingUser: true,
        errorUser: null,
        registerSuccess: false
      };
    case REGISTER_USER_SUCCESS:
      return {
        ...state,
        loadingUser: false,
        registerSuccess: true
      };
    case REGISTER_USER_FAILURE:
      return {
        ...state,
        loadingUser: false,
        errorUser: action.payload,
        registerSuccess: false
      };
      
    case ACTIVATE_ACCOUNT_REQUEST:
      return {
        ...state,
        activationLoadingUser: true,
        activationError: null,
        activationSuccess: false
      };
    case ACTIVATE_ACCOUNT_SUCCESS:
      return {
        ...state,
        activationLoadingUser: false,
        activationSuccess: true
      };
    case ACTIVATE_ACCOUNT_FAILURE:
      return {
        ...state,
        activationLoadingUser: false,
        activationError: action.payload,
        activationSuccess: false
      };
    case VERIFY_USER_REQUEST:
      return {
        ...state,
        loadingUser: true,
        errorUser: null
      };
    case VERIFY_USER_SUCCESS:
      return {
        ...state,
        loadingUser: false,
        userVerified: true
      };
    case VERIFY_USER_FAILURE:
      return {
        ...state,
        loadingUser: false,
        errorUser: action.payload
      };
    case ACTIVATE_USER_REQUEST:
      return {
        ...state,
        loadingUser: true,
        errorUser: null
      };
    case ACTIVATE_USER_SUCCESS:
      return {
        ...state,
        loadingUser: false,
        userVerified: true
      };
    case ACTIVATE_USER_FAILURE:
      return {
        ...state,
        loadingUser: false,
        errorUser: action.payload
      };
    case BAN_USER_REQUEST:
      return {
        ...state,
        loadingUser: true,
        errorUser: null
      };
    case BAN_USER_SUCCESS:
      return {
        ...state,
        loadingUser: false,
        userVerified: true
      };
    case UPDATE_USERS_FAILURE:
      return {
        ...state,
        loadingUser: false,
        errorUser: action.payload
      };
    case RESEND_ACTIVATION_EMAIL_REQUEST:
      return {
        ...state,
        resendLoading: true,
        resendError: null,
        resendSuccess: false
      };
    case RESEND_ACTIVATION_EMAIL_SUCCESS:
      return {
        ...state,
        resendLoading: false,
        resendSuccess: true
      };
    case RESEND_ACTIVATION_EMAIL_FAILURE:
      return {
        ...state,
        resendLoading: false,
        resendError: action.payload,
        resendSuccess: false
      };
    case SEND_EMAIL_ADMIN_REQUEST:
      return {
        ...state,
        sendAdminLoading: true,
        sendAdminError: null,
        sendAdminSuccess: false
      };
    case SEND_EMAIL_ADMIN_SUCCESS:
      return {
        ...state,
        sendAdminLoading: false,
        sendAdminSuccess: true
      };
    case SEND_EMAIL_ADMIN_FAILURE:
      return {
        ...state,
        sendAdminLoading: false,
        sendAdminError: action.payload,
        sendAdminSuccess: false
      };
    case CLEAR_USER_ERRORS:
      return {
        ...state,
        errorUser: null,
        errorsUser: null,
        activationError: null,
        resendError: null,
        sendAdminError: null
      };
    case CLEAR_USER_SUCCESS:
      return {
        ...state,
        success: false,
        userAdded: null,
        passwordResetSuccess: false,
        registerSuccess: false,
        activationSuccess: false,
        resendSuccess: false,
        sendAdminSuccess: false
      };
      
    default:
      return state;
  }
};

export default Users;